import * as React from "react";
import styles from '../styles/collectie.module.scss';
import { ImageFit, IStackTokens, Image, Stack } from "@fluentui/react";
import LanguageFC from "./Language";
import GlobalContext from "../_contexts/GlobalContext";
import { useContext } from "react";

export interface IHeaderFCProps {
    // eslint-disable-next-line
}

const HeaderFC : React.FunctionComponent<IHeaderFCProps> = (props : IHeaderFCProps) => {
    const [siteImage, setSiteImage] = React.useState<string>(`${process.env.PUBLIC_URL}/assets/sitebanner.png`);
    const { GlobalImagesVersion, BANNER_COLOR } = useContext(GlobalContext);
    
    React.useEffect(() => {
        if (window.location.host.endsWith('.collectietekoop.nl')) {
            setSiteImage(`${process.env.PUBLIC_URL}/assets/${window.location.host}.webp`);
        }
    },[]);

    return (
        <div className={`${styles.headerMain}`} style={{backgroundColor:BANNER_COLOR,backgroundImage:`url('${process.env.PUBLIC_URL}/assets/container_bg.webp?v=${GlobalImagesVersion}')`}}>
            <Stack horizontal horizontalAlign='center' style={{width:"100%"}}>
                <Image onClick={() => {window.location.href = '/'}} className={styles.mainLogo} src={`${siteImage}?v=${GlobalImagesVersion}`} alt="" imageFit={ImageFit.contain} />  
                <LanguageFC/>
            </Stack>
        </div>
    );
}

export default HeaderFC;